import lodash from 'lodash';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel } from '../bases';
import { XiaozhiController } from './index';
export class PromptController {
  constructor(public Xiaozhi: XiaozhiController) {}
  Model = new BaseModel({ type: 'object' });
  get dataSource() {
    return lodash.get(this.Model.value, 'dataSource');
  }
  get loading() {
    return lodash.get(this.Model.value, 'loading');
  }
  onToggleLoading(value) {
    this.Model.merge({
      loading: value,
    });
  }
  /**
   * 推荐问列表
   * @param
   */
  async onPrompt() {
    try {
      this.onToggleLoading(true);
      const headers = await this.Xiaozhi.getHeader();
      const res: any = await AjaxBasics.request({
        ...EnumAPI.lcicsp_prompt,
        headers,
      });
      this.Model.merge({
        dataSource: res.prompts,
      });
    } catch (error) {}
    this.onToggleLoading(false);
  }
}
